import CustomButton from "@/components/CustomButton";
import { IS_PRODUCTION } from "@/constants/constants";
import { getHouseholdPrintFileName } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useBSPrint } from "@/hooks/useBSPrint";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

type Props = {
  isNonAssetBalanceSheet: boolean;
};

export default function PrintButton({ isNonAssetBalanceSheet }: Props) {
  const { mutateAsync: downloadAsync, error: printErrorMsg } = useBSPrint();
  const {
    household,
    header: { isError },
  } = useAppSelector((state) => state.household);

  const { isAssetsLayoutChanged } = useAppSelector((state) => state.balanceSheet);

  const fileName = getHouseholdPrintFileName({
    clientCode: household?.clientCode,
    tabName: isNonAssetBalanceSheet ? "Non-Asset Balance Sheet" : "Balance Sheet",
  });

  const toastMessages = {
    pending: isNonAssetBalanceSheet
      ? "Downloading non-asset balance sheet.."
      : "Downloading balance sheet..",
    success: isNonAssetBalanceSheet
      ? "Non-asset balance sheet downloaded!"
      : "Balance sheet downloaded!",
    error:
      printErrorMsg instanceof AxiosError
        ? printErrorMsg.message
        : isNonAssetBalanceSheet
          ? "Downloading non-asset balance sheet failed"
          : "Downloading balance sheet failed",
  };

  if (IS_PRODUCTION || isError) return null;

  return (
    <div>
      <CustomButton
        className="screen:mt-4 print:hidden"
        text={"Print to PDF"}
        disabled={isAssetsLayoutChanged}
        onClickHandler={() => {
          toast.promise(
            downloadAsync({
              id: household?.externalCode,
              fileName,
              isNonAssetBalanceSheet,
            }),
            toastMessages
          );
        }}
      />
    </div>
  );
}
